import React, { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { API } from "@/lib/api";
import { LogIn } from "lucide-react";

const GoogleButton = ({ onClick }) => (
  <button onClick={onClick} className="w-full bg-white text-black rounded-full py-3.5 font-display font-bold text-sm uppercase tracking-wider hover:bg-[#00F0FF] transition-all flex items-center justify-center gap-3">
    <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3a12 12 0 0 1-23.3-4 12 12 0 0 1 20.4-8.5l5.7-5.7A20 20 0 1 0 44 24c0-1.2-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8A12 12 0 0 1 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.7 5.9 29.1 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5 0 9.6-1.9 13-5l-6-5.1A12 12 0 0 1 12.7 28L6.2 33.1A20 20 0 0 0 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3a12 12 0 0 1-4.1 5.9L37 39c-.4.4 6.2-4.5 6.2-15a17 17 0 0 0-.4-3.5z"/></svg>
    Continuer avec Google
  </button>
);

export default function LoginForm({ title = "Connexion", subtitle = "Connecte-toi avec ton compte La Fribue habituel.", onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      onSuccess?.(user);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  // origin transmis en state Google - le backend ne l'utilise que s'il
  // correspond à une origine connue (cf. ALLOWED_FRONTEND_ORIGINS côté
  // serveur), donc pas de risque à l'envoyer tel quel.
  const googleLogin = () => {
    window.location.href = `${API}/auth/google/login?origin=${encodeURIComponent(window.location.origin)}`;
  };

  return (
    <div className="max-w-sm mx-auto px-5 pt-16 pb-16">
      <h1 className="font-display font-black text-2xl tracking-tight mb-2 text-center">{title}</h1>
      <p className="text-white/50 text-sm text-center mb-8">{subtitle}</p>
      <div className="card-glass p-6 space-y-4">
        <GoogleButton onClick={googleLogin} />
        <div className="flex items-center gap-3 text-[11px] text-white/30 uppercase tracking-widest">
          <div className="flex-1 h-px bg-white/10" /> ou <div className="flex-1 h-px bg-white/10" />
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#14141A] border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#00F0FF]" />
          <input type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#14141A] border border-white/10 rounded-xl px-4 py-3 outline-none focus:border-[#00F0FF]" />
          <button type="submit" disabled={loading} className="btn-neon w-full !py-3 disabled:opacity-50">
            <LogIn size={16} /> {loading ? "..." : "Se connecter"}
          </button>
        </form>
      </div>
      <p className="text-[11px] text-white/30 text-center mt-4">
        Pas encore de compte ? Rejoins l'association sur <a href="https://lafribue.fr/adhesion" className="hover:text-white transition underline">lafribue.fr</a>.
      </p>
    </div>
  );
}
